import { Platform, PlatformIOSStatic, StatusBar, StyleSheet } from 'react-native'

import { fontFamily } from '../../theme/fontFamily'
import { DS } from '../../design-system'

export const isIPad = Platform.OS === 'ios' ? (Platform as PlatformIOSStatic).isPad : false

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F6F2E9',
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
  },
  lessonHeader: {
    fontSize: 14,
    fontFamily: fontFamily.GTAmericaExtended,
    fontWeight: '700',
    color: '#000',
    textTransform: 'uppercase'
  },
  lessonDesicription: {
    fontSize: 15,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    marginTop: 10,
    color: '#000'
  },
  swiperStyle: {
    marginLeft: 24
  },
  GameCardContainer: {
    flex: 1,
    flexDirection: 'row'
  },
  gameView: {
    width: '95%',
    flexDirection: 'row'
  },
  gameCard: {
    height: 110,
    width: 110,
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center'
  },
  gameIconStyle: {
    height: 60,
    width: 67
  },
  createIconStyle: {
    height: 77,
    width: 77,
    bottom: 0
  },
  practiceIconStyle: {
    height: 94,
    width: 49,
    bottom: 0
  },
  gametitleContainer: {
    paddingLeft: 16,
    flex: 1
  },
  gameTitle: {
    fontSize: 17,
    fontFamily: fontFamily.GTAmericaStandardMedium,
    fontWeight: '500',
    marginTop: 10
  },
  description: {
    fontSize: 14,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    marginTop: 10
  },
  rightArrowContainer: {
    width: '10%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  referContainer: {
    marginTop: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    height: 104,
    borderWidth: 8,
    borderColor: '#5BC4FF',
    borderBottomColor: '#38443f',
    borderTopColor: '#38443f'
  },
  referText: {
    fontSize: 20,
    fontFamily: fontFamily.GTAmericaStandardMedium,
    color: '#121212'
  },
  virtualClassHeading: {
    color: '#121212',
    textAlign: 'center',
    fontFamily: fontFamily.FeatureDeckRegular,
    fontSize: 24
  },
  virtualClassSubHeading: {
    color: '#121212',
    fontSize: 16,
    textAlign: 'center',
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  virtualClassSignupButton: {
    paddingVertical: 10,
    paddingHorizontal: 25,
    width: 120,
    alignSelf: 'center'
  },
  virtualClassBottomChips: {
    width: 100,
    height: 100,
    bottom: -35,
    left: 9,
    transform: [{ rotate: '340deg' }],
    position: 'absolute'
  },
  virtualClassTopChips: {
    position: 'absolute',
    right: 20,
    width: 80,
    height: 80,
    top: -20
  },
  virtualClassCardContainer: {
    backgroundColor: '#E9E238',
    height: 230,
    width: '100%',
    borderRadius: 8,
    paddingVertical: DS.spacing[48],
    gap: DS.spacing[12]
  },
  welcomeMsg: {
    color: '#121212',
    fontSize: 32,
    fontFamily: fontFamily.FeatureDeckRegular
  },
  welcomeBackMsg: {
    color: '#121212',
    fontSize: 24,
    fontFamily: fontFamily.FeatureDeckMedium
  }
})

export default styles
